export default function SwitchPortalPlumIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <g clip-path="url(#clip0_7991_24488)">
        <path
          d="M1.5 2.19C1.5 1.68595 1.5 1.43393 1.59342 1.24141C1.6756 1.07206 1.80673 0.93438 1.96801 0.848094C2.15136 0.75 2.39138 0.75 2.87143 0.75H6.12857C6.60862 0.75 6.84864 0.75 7.03199 0.848094C7.19327 0.93438 7.3244 1.07206 7.40658 1.24141C7.5 1.43393 7.5 1.68595 7.5 2.19V8.31C7.5 8.81405 7.5 9.06607 7.40658 9.25859C7.3244 9.42794 7.19327 9.56562 7.03199 9.65191C6.84864 9.75 6.60862 9.75 6.12857 9.75H2.87143C2.39138 9.75 2.15136 9.75 1.96801 9.65191C1.80673 9.56562 1.6756 9.42794 1.59342 9.25859C1.5 9.06607 1.5 8.81405 1.5 8.31V2.19Z"
          stroke="#4C0F28"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.5 10.32C10.5 9.85796 10.5 9.62694 10.5934 9.45046C10.6756 9.29522 10.8067 9.16902 10.968 9.08992C11.1514 9 11.3914 9 11.8714 9H15.1286C15.6086 9 15.8486 9 16.032 9.08992C16.1933 9.16902 16.3244 9.29522 16.4066 9.45046C16.5 9.62694 16.5 9.85796 16.5 10.32V15.93C16.5 16.392 16.5 16.6231 16.4066 16.7995C16.3244 16.9548 16.1933 17.081 16.032 17.1601C15.8486 17.25 15.6086 17.25 15.1286 17.25H11.8714C11.3914 17.25 11.1514 17.25 10.968 17.1601C10.8067 17.081 10.6756 16.9548 10.5934 16.7995C10.5 16.6231 10.5 16.392 10.5 15.93V10.32Z"
          stroke="#4C0F28"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 6.75C15 3.8505 12.6495 1.5 9.75 1.5"
          stroke="#4C0F28"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 12C3 14.8995 5.3505 17.25 8.25 17.25"
          stroke="#4C0F28"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7991_24488">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
